import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import StickyMobileCTA from "@/components/StickyMobileCTA";
import BookingModal from "@/components/BookingModal";
import TrustBar from "@/components/TrustBar";
import Hero from "@/components/sections/Hero";
import Intro from "@/components/sections/Intro";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import LashLooks from "@/components/sections/LashLooks";
import CustomStyling from "@/components/sections/CustomStyling";
import Portfolio from "@/components/sections/Portfolio";
import Location from "@/components/sections/Location";
import FAQ from "@/components/sections/FAQ";
import InstagramGallery from "@/components/sections/Instagram";
import FinalCTA from "@/components/sections/FinalCTA";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { TIMELY_BOOKING_URL } from "@/lib/booking";

export default function Landing() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname === "/book") window.location.replace(TIMELY_BOOKING_URL);
  }, [pathname]);

  return (
    <div className="bg-[#080808]">
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <Intro />
        <About />
        <Services />
        <LashLooks />
        <CustomStyling />
        <Portfolio />
        <Location />
        <FAQ />
        <InstagramGallery />
        <FinalCTA />
      </main>
      <Footer />
      <StickyMobileCTA />
      <BookingModal />
    </div>
  );
}
